import type { Calculation } from "~/tools/calculate-value-from-points";
import type { FormatterUnit } from "~/tools/formatter-unit";

import { HEALTHY as HEALTHY_COLOR } from "../color/settings";
import type { Mode as ThresholdsMode, Step as ThresholdsStep } from "../thresholds/settings";

interface Settings {
	unit?: string;
	decimals?: number;
	max?: number;
	calculation?: Calculation;
	color?: string;

	thresholds?: {
		mode?: ThresholdsMode;
		steps?: ReadonlyArray<ThresholdsStep>;
	};
}

const DEFAULT = {
	unit: "percentunit" satisfies FormatterUnit,
	decimals: undefined,
	max: 1,
	calculation: "last",
	color: HEALTHY_COLOR,
	thresholds: {
		mode: "absolute",
		steps: [],
	},
} as const satisfies Settings;

export { DEFAULT };
export type { Settings };
